// extracted by mini-css-extract-plugin
export default {"container":"MypageForm_container__BPNtN","buttonWrap":"MypageForm_buttonWrap__9H9w3"};